const getApiUrl = (version, host) => {
  if (!host) {
    return `v${version}`;
  }
  return new URL(`v${version}`, host).href;
};

export default getApiUrl;
